import { Checkbox, InputAdornment, TextField } from "@material-ui/core";
import clsx from "clsx";
import { ChangeEvent, useEffect, useState } from "react";
import "../../../scss/tipping.scss";
import { useTranslation } from "react-i18next";
import { ITippingOption } from "../../tipping/types";

interface IFormTippingElementProps extends ITippingOption {
    onChange: (keyName: string, state: any) => void;
    formData: any;
    errors: any;
    fixed: boolean;
    formState: any;
    keyName: string;
    disabled?: boolean;
}
const initalObj = {
    enabled: false,
    value: 0

}
export function FormTippingElement({
    fixed,
    onChange,
    keyName,
    formData,
    text,
    errors,
    disabled,
    ...rest
}: IFormTippingElementProps) {
    const { t } = useTranslation();
    const [elementState, setElementState] = useState(initalObj);
    const [isDisabled, setIsDisabled] = useState(disabled);
    const { enabled, value } = elementState;


    useEffect(() => {
        if (formData && formData !== elementState) {
            setElementState(formData);
        }
        //eslint-disable-next-line
    }, [formData]);

    useEffect(() => {
        const copy = { ...rest.formState }
        delete copy.tipping;
        delete copy.tipping_enabled;

        const enabledOptions = new Set(
            Object.entries(copy)
            .filter(([, item]: [string, any]) => item?.enabled)
            .map(([key, ]: [string, any]) => key)
        );

        
        if (enabledOptions.size >= 4 && !enabledOptions.has(keyName)) {
            setIsDisabled(true || disabled);
        } else {
            setIsDisabled(false || disabled);
        }
    }, [rest.formState, keyName, disabled]);

    const classnames = clsx("tipping", {
        "tipping-fixed": fixed,
    });


    const hasError = () => !!Object.keys(errors || {}).length;

    function onChangeState(name: string, value: any) {
        setElementState((prevState: any) => {
            const newStateObj = {
                ...prevState,
                [name]: value
            }
            onChange(name, newStateObj);
            return newStateObj
        });
    }
    function handleChangeEvent(ev: ChangeEvent<HTMLInputElement>) {
        const name = ev.target.name;
        const value = ev.target.value;
        onChangeState(name, value);
    }
    function handleChangeEventCheckbox(ev: ChangeEvent<HTMLInputElement>) {
        const name = ev.target.name;
        const value = ev.target.checked;
        onChangeState(name, value);
    }
    function handleBlurInput(ev: any) {
        let value = ev.target.value || null;
        const name = ev.target.name;

        if (!value || value < 0) {
            value = 0;
        }

        onChangeState(name, value);
    }

    return (
        <>
            <div
                className={`${classnames} ${hasError() ? 'tipping-error' : ''}`}
                data-component-name="TIPPING_OPTION"
            >
                <Checkbox
                    name="enabled"
                    onChange={handleChangeEventCheckbox}
                    color="primary"
                    checked={Boolean(enabled)}
                    disabled={isDisabled}
                    data-component-name={`TIPPING_CHECKBOX_${keyName}`}
                    className={enabled ? "CHECKED" : "UNCHECKED"}
                />

                {fixed && (
                    <TextField
                        onChange={handleChangeEvent}
                        name={`${keyName}_enabled`}
                        value={t(text).toString()}
                        variant="outlined"
                        disabled={true}
                        fullWidth
                        data-component-name={`TIPPING_INPUT_${keyName}`}
                    />
                )}

                {!fixed && (
                    <div className='text-field-wrapper'>
                        <TextField
                            name={`value`}
                            type="number"
                            value={value}
                            inputProps={{ step: "0.1", max: "100" }}
                            variant="outlined"
                            onChange={handleChangeEvent}
                            onBlur={handleBlurInput}
                            disabled={isDisabled}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end"> | %</InputAdornment>
                                ),
                            }}
                            data-component-name={`TIPPING_INPUT_${keyName}`}
                        />
                    </div>
                )}

                {!fixed && <div className="tipping-text">{t(text)}</div>}
            </div>
        </>
    );
}
